import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './BetaGate.css';

const EarlyAccess = () => {
  const navigate = useNavigate();
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    // Auto-grant beta access for the Original 40 — they bypass the gate forever on this device
    localStorage.setItem('beatseek_beta_access', 'true');
    localStorage.setItem('beatseek_founding_40', 'true');

    // Floating particles (matches BetaGate vibe)
    const newParticles = Array.from({ length: 25 }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      top: Math.random() * 100,
      delay: Math.random() * 6,
      duration: 4 + Math.random() * 6,
    }));
    setParticles(newParticles);
  }, []);

  const handleEnter = () => {
    navigate('/');
  };

  return (
    <div className="beta-gate" data-testid="early-access-page">
      {/* Animated Background */}
      <div className="gate-bg">
        {/* Gradient Orbs */}
        <div className="gradient-orb gradient-orb-1"></div>
        <div className="gradient-orb gradient-orb-2"></div>
        <div className="gradient-orb gradient-orb-3"></div>

        {/* Grid Overlay */}
        <div className="grid-overlay"></div>

        {/* Floating Music Notes */}
        <div className="music-notes-container">
          {['♪', '♫', '♬', '♩', '𝄞', '♪', '♫', '♬', '♩', '𝄢', '♪', '♫', '♬', '♩', '♪'].map((note, i) => (
            <div
              key={i}
              className="floating-note"
              style={{
                left: `${5 + (i * 6.5)}%`,
                animationDelay: `${i * 0.6}s`,
                fontSize: `${18 + (Math.sin(i * 1.5) + 1) * 15}px`,
                animationDuration: `${8 + Math.random() * 4}s`,
              }}
            >
              {note}
            </div>
          ))}
        </div>

        {/* Floating Particles */}
        <div className="particles-container">
          {particles.map((p) => (
            <div
              key={p.id}
              className="particle"
              style={{
                left: `${p.left}%`,
                top: `${p.top}%`,
                animationDelay: `${p.delay}s`,
                animationDuration: `${p.duration}s`,
              }}
            />
          ))}
        </div>
      </div>

      {/* Main Content */}
      <div className="gate-content">
        {/* Vinyl Record */}
        <div className="vinyl-record">
          <div className="vinyl-grooves"></div>
          <div className="vinyl-label"></div>
          <div className="vinyl-center"></div>
        </div>

        {/* Logo + Tagline */}
        <div className="gate-header">
          <div className="logo-container">
            <div className="logo-glow"></div>
            <h1 className="gate-title">
              <span className="title-beat">BEAT</span>
              <span className="title-seek">SEEK</span>
            </h1>
          </div>
          <p className="ea-tagline">ONE PLATFORM. INFINITE VIBES.</p>
        </div>

        {/* Original 40 Badge */}
        <div className="ea-badge" data-testid="og40-splash-badge">
          <span className="ea-badge-star">🌟</span>
          <span className="ea-badge-text">ORIGINAL 40</span>
          <span className="ea-badge-star">🌟</span>
        </div>

        {/* Welcome copy */}
        <h2 className="ea-welcome">Welcome, Founding Member.</h2>
        <p className="ea-body">
          The wait is over. You're one of the first <strong>40</strong> to step inside the
          home of electronic music's discovery, sound, and culture.
        </p>
        <p className="ea-body ea-body-soft">
          Your seat is saved. Your badge is waiting. Let's build this together.
        </p>

        <button
          className="ea-cta"
          onClick={handleEnter}
          data-testid="early-access-enter-btn"
        >
          <span className="ea-cta-arrow">▶</span>
          ENTER BEATSEEK
        </button>

        <p className="ea-footnote">Already have an account? Just log in.</p>
      </div>
    </div>
  );
};

export default EarlyAccess;
